export default "__VITE_ASSET__BPHwjfTp__"